// extracted by mini-css-extract-plugin
var _1 = "GraphTableHeading__col--Y46tn";
var _2 = "GraphTableHeading__lockIcon--_9pAq";
var _3 = "GraphTableHeading__main--XMrmB";
var _4 = "GraphTableHeading__trophyImg--ZY6Dj";
export { _1 as "col", _2 as "lockIcon", _3 as "main", _4 as "trophyImg" }
